import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import ArticleBody from '../ArticleBody';
import messages from '../../../messages';

const AdjustingToHybrid = () => (
  <div>
    <ArticleBody>
      <FormattedHTMLMessage tagName="p" {...messages.adjustHybridBody} />
    </ArticleBody>
  </div>
);

AdjustingToHybrid.propTypes = {};

export default AdjustingToHybrid;
